<template>
  <div class="alignCenter">
    <van-nav-bar title="诊断报告详情" left-arrow @click-left="goback" left-text="返回" id="reset"/>
    <!-- <van-panel title="基本信息" desc="客户基本信息" > -->
    <section class="contentBox">
      <header>
        <span>基本信息</span>
      </header>
      <div>
        <van-field
          label="姓名："
          v-model="form.name"
          name="pattern"
          placeholder="姓名"
        />
        <van-field
          label="年龄："
          v-model="age"
          name="pattern"
          placeholder="年龄"
        />
        <van-field
          label="性别："
          v-model="form.gender"
          name="pattern"
          placeholder="性别"
        />
        <van-field
          label="联系电话："
          v-model="form.userInfoTeleNum"
          name="pattern"
          placeholder="联系电话"
        />
         <!-- <van-field
          label="体重/kg："
          v-model="form.weight"
          name="pattern"
          placeholder="体重"
        />
        <van-field
          label="身高/cm："
          v-model="form.height"
          name="pattern"
          placeholder="身高"
        /> -->
        <!-- <van-field
          label="单位/职务："
          v-model="form.profession"
          name="pattern"
          placeholder="单位/职务..."
        />
        <van-field
          label="出生日期："
          v-model="form.birthDate"
          name="pattern"
          placeholder="出生日期"
        /> -->
      </div>
    </section>
    <!-- </van-panel> -->

    <section class="contentBox">
      <header>
        <span>检测结果及健康建议</span>
      </header>
      <div style="padding:16px">
        <article class="prescription" v-html="prescription">
        </article>
      </div>
    </section>
    
    <!-- <van-panel title="检测结果及健康建议" desc="医生处方" :status="status">
      <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o" wrapable
        :scrollable="false"
      >
        {{prescription}}
      </van-notice-bar>
    </van-panel> -->
  </div>
</template>

<script>
import Moment from "moment";
import {formatText} from "../../../utils/util.js"
import { getCurrentUserByToken , getUserInfo ,getUserAllExam} from "../../../api/userService";

export default {
  name: "login",
  data() {
    return {
      teleNum: sessionStorage.getItem("teleNum"),
      form: {
        name: "",
        gender:'',
        userInfoTeleNum:"",
        weight:"",
        profession:"",
        height:"",
        birthDate:""
      },
      status:"检测还未完成",
      prescription:"",
    };
  },
  computed:{

    age() {  
      const today = new Date();  
      const birthDate = new Date(this.form.birthDate.replace(/-/g, "/"));  
      let age = today.getFullYear() - birthDate.getFullYear();  
      const monthDiff = today.getMonth() - birthDate.getMonth();  
      const dayDiff = today.getDate() - birthDate.getDate();  
      
      // If current month is before birth month,  
      // or same month but current date is before birth date => subtract one year  
      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {  
        age--;  
      }  
      
      return age;  
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this._getCurrentUser();
    this._getUserAllExam();
  },
  // 里面的函数只有调用才会执行
  methods: {
        //获取当前用户信息
    _getCurrentUser() {
      getCurrentUserByToken().then((res) => {
        if (res.userInfo) {
          this.formBasicInfo = res.userInfo;
        } else{
          this._getUserInfo()
        }
      })
      .catch( e => {
        this._getUserInfo()
        this.$message({ message: "获取当前用户信息失败," + e , type: "error" });
      });
    },
    _getUserInfo() {
      //我的诊断中获取用户基本信息
      getUserInfo(this.teleNum ).then((res) => {
        //基础信息
        if( res.data[0] ) {
          this.form = res.data[0];
          this.form.birthDate = Moment(this.form.birthDate).format("YYYY-MM-DD")
        }
      });
    },
    linkfy(text) {
          var urlRegex = /(https?:\/\/[^\s]+)/g;
          return text.replace(urlRegex, function(url) {
            return '<a href="' + url + '">' + url + '</a>';
          })
    },

    //获取用户所有的检测记录；
    _getUserAllExam(){
      getUserAllExam(this.teleNum)
      .then(res => {
        if(res.success){
          if(res.data[0].length>0) {
            for(let i = 0; i < res.data[0].length; i++) {
              if(res.data[0][i].examHyperq&&res.data[0][i].examHyperq.hyperqFile) {
                this.prescription += ("检查时间："+res.data[0][i].medCheckResource.checkTime +";"+ this.linkfy(res.data[0][i].examHyperq.hyperqFile)+ '<br>');
              }
            }
            this.prescription += ("最近一次健康建议：<br>"+ formatText(res.data[0][0].prescription));
            this.status = "检测已完成";
          }
          else{
            this.prescription = "检测还未结束，暂无检测结果及健康建议";
            this.status = "检测还未完成";
          }
          
          // console.log("prescription",res.data[0][res.data[0].length -1].prescription)
        }
        else{
          this.$message({ message: res.description, type: "error" });
        }
      })
      .catch(e =>{
        console.log(e)
      })
    },
    goback(){
       this.$router.go(-1);
    },
  },
};
</script>

<style lang=less scoped>
*{
  font-size:18px;
}
/**style for top bar */
.van-nav-bar {
  background: linear-gradient(to right, #77bbe3, #1270c6);
}
#reset /deep/ .van-ellipsis {
  font-size: 18px;
  color: white !important;
}
#reset /deep/ .van-nav-bar__text {
  color: white !important;
}
/** top bar style end*/

.contentBox{
  margin:20px;
}

.contentBox header{
  background:#4285C3;
  height:35px;
  color:white;
  /* padding:12px 0 0 10px;   */
  /* vertical-align: middle; */
  /* line-height:100%; */
  padding:12px 0 0 10px;
  border-radius: 5px 5px 0 0;

}

.contentBox header span{
  font-size:18px;
  color:white;
  /* vertical-align: middle; */
  
}

.contentBox div{
  background:#F8F8F8;
  border-radius:  0 0 5px 5px;
  background:#F8F8F8;
  /* padding:20px; */
}

.prescription{
  background: white;
}
</style>